export const PRIZM_CHROMIUM_EDGE_START_VERSION = 79;
